<template>
  <section :class="$style.product_list">
    <PagePartsProductListItem
      v-for="product in state.products"
      :key="product.document_id"
      :product="product"
      is-no-validation
      @open-fav-modal="openFavModal($event, product)"
    />
    <!-- お気に入りモーダル -->
    <MoleculesConsumerModal v-model="isOpenFavModal">
      <ProductSelectFav
        :product="favModalProduct"
        :favorite-list="favoriteListRef"
        :is-processing="isProcessing"
        @on-favorite="onFavoriteByProductList"
        @lift="() => (isOpenFavModal = false)"
      />
    </MoleculesConsumerModal>
  </section>
</template>

<script setup lang="ts">
import { PagePartsProductType } from "~/types/product"
import { useFavorite } from "~/composables/useFavorite"

const { openFavModal, onFavoriteByProductList, isOpenFavModal, favModalProduct, favoriteListRef, isProcessing } =
  useFavorite()

type Props = {
  products: PagePartsProductType[]
}

const props = withDefaults(defineProps<Props>(), {
  products: () => [],
})

interface State {
  products: PagePartsProductType[]
}

const state = ref<State>({
  products: [],
})

state.value.products = props.products
</script>

<style scoped module lang="scss">
.product_list {
  width: 100%;
  max-width: $max-width-md;
  display: grid;
  grid-template-columns: repeat(auto-fit, calc(100% / 2 - (0.5rem / 2)));
  column-gap: 0.5rem;
  row-gap: 1rem;
  margin: 1rem auto;
  @include md {
    grid-template-columns: repeat(auto-fit, calc(100% / 3 - (1rem / 3 * 2)));
    column-gap: 1rem;
    row-gap: 1.5rem;
    margin-bottom: 2rem 0 5rem;
  }
}
</style>
